import React from "react";

export default class GradedInSearchComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "lookup",
            vendors: props.vendors || [],
            selectedVendor: "",
            patterns: [],
            selectedPattern: "",
            gradeInput: "",
            results: [],
            searching: false,
            searched: false
        };
    }

    onTabChange = (tab) => {
        this.setState({ activeTab: tab, results: [], searched: false, selectedVendor: "", selectedPattern: "", gradeInput: "", patterns: [] });
    }

    onVendorChange = (e) => {
        var vendor = e.target.value;
        this.setState({ selectedVendor: vendor, selectedPattern: "", patterns: [] });
        if (!vendor) return;
        fetch("/api/Vendor/Patterns?vendor=" + encodeURIComponent(vendor))
            .then(function (res) { return res.json(); })
            .then((patterns) => {
                this.setState({ patterns: patterns });
            });
    }

    onPatternChange = (e) => {
        this.setState({ selectedPattern: e.target.value });
    }

    onGradeChange = (e) => {
        this.setState({ gradeInput: e.target.value });
    }

    onGradeLookup = () => {
        var vendor = this.state.selectedVendor;
        var pattern = this.state.selectedPattern;
        if (!vendor) return;
        this.setState({ searching: true, searched: false });
        var url = "/api/Vendor/GradeLookup?vendor=" + encodeURIComponent(vendor);
        if (pattern) url += "&pattern=" + encodeURIComponent(pattern);
        fetch(url)
            .then(function (res) { return res.json(); })
            .then((results) => {
                this.setState({ results: results, searching: false, searched: true });
            });
    }

    onSearchByGrade = () => {
        var grade = this.state.gradeInput.trim();
        if (!grade) return;
        this.setState({ searching: true, searched: false });
        fetch("/api/Vendor/SearchByGrade?grade=" + encodeURIComponent(grade))
            .then(function (res) { return res.json(); })
            .then((results) => {
                this.setState({ results: results, searching: false, searched: true });
            });
    }

    onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (this.state.activeTab === "lookup") this.onGradeLookup();
            else this.onSearchByGrade();
        }
    }

    render() {
        var activeTab = this.state.activeTab;
        var results = this.state.results;
        var vendors = this.state.vendors;
        var patterns = this.state.patterns;

        return (
            <div className="graded-in-search">
                <div className="graded-in-tabs">
                    <button className={"graded-in-tab" + (activeTab === "lookup" ? " active" : "")} onClick={() => this.onTabChange("lookup")}>Grade Lookup</button>
                    <button className={"graded-in-tab" + (activeTab === "grade" ? " active" : "")} onClick={() => this.onTabChange("grade")}>Search by Grade</button>
                </div>

                {activeTab === "lookup" && (
                    <div className="graded-in-search-row">
                        <select value={this.state.selectedVendor} onChange={this.onVendorChange}>
                            <option value="">Select Program Partner</option>
                            {vendors.map(function (v) {
                                return <option key={v} value={v}>{v}</option>;
                            })}
                        </select>
                        <select value={this.state.selectedPattern} onChange={this.onPatternChange}>
                            <option value="">Enter Pattern</option>
                            {patterns.map(function (p) {
                                return <option key={p} value={p}>{p}</option>;
                            })}
                        </select>
                        <button className="ui-button-configure ink" onClick={this.onGradeLookup}>SEARCH <img src="/images/icons/arrow.png" /></button>
                    </div>
                )}

                {activeTab === "grade" && (
                    <div className="graded-in-search-row">
                        <input type="text" placeholder="Enter Grade (e.g., U45)" value={this.state.gradeInput} onChange={this.onGradeChange} onKeyDown={this.onKeyDown} />
                        <button className="ui-button-configure ink" onClick={this.onSearchByGrade}>SEARCH <img src="/images/icons/arrow.png" /></button>
                    </div>
                )}

                {this.state.searching && <div className="graded-in-loading">Searching...</div>}

                {this.state.searched && results.length === 0 && (
                    <div className="graded-in-no-results">No results found.</div>
                )}

                {results.length > 0 && (
                    <div className="graded-in-results">
                        <table>
                            <thead>
                                <tr>
                                    <th>Vendor</th>
                                    <th>Pattern</th>
                                    <th>Grade</th>
                                </tr>
                            </thead>
                            <tbody>
                                {results.map(function (r) {
                                    return (
                                        <tr key={r.id}>
                                            <td>{r.vendor}</td>
                                            <td>{r.pattern}</td>
                                            <td>{r.grade}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}
